<template>
  <div class="modal micromodal-slide change_data" v-bind:class="{ 'is-open': this.open }">
    <!-- <div class="bg" v-bind:class="{'open': this.open}"></div> -->
    <div class="modal__overlay" v-on:click="close()"></div>
    <div class="modal_item">
      <div class="detail_wrap">
        <button v-on:click="close()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
        <h2 class="content_title">登録クレジットカード</h2>
        <div v-if="cardList.length != 0" class="scroll mt24" ref="modal__content">
          <div v-for="(item, n) in cardList" class="credit_item right_arrow bdb pl16 pr20 pb10" :class="{ 'pt11': n != 0 }">
            <input v-bind:id="'credit' + n" class="payment_radio" type="radio" name="credit" :checked="creditData.creditCardId == item.creditCardId">

            <label v-bind:for="'credit' + n" class="payment_contents credit_contents rb" v-on:click="changeCredit(item.creditCardId)">
              <span class="credit_image"><img v-bind:src="require('../../assets/images/credit/' + item.cardBrand + '.png')" alt=""></span>
              <span class="credit_number ar">{{ item.cardNo }}</span>
            </label>
          </div>
        </div>
        <div v-else class="pt19 pl16 pr20 pb10">クレジットカードが登録されていません</div>
      </div>
      <div class="btn_wrap">
        <button v-if="cardList.length != 0" v-on:click="changeCard()" class="btn_yellow">このカードを使う</button>
        <a href="#" class="btn_blue" @click.stop.prevent="addCard()">クレジットカードを追加</a>
      </div>

    </div>
  </div>
</template>

<script>
import creditCard from '@/components/api/creditCard'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';

export default {
  props: ['pageName'],
  data() {
    return {
      open: false,
      cardList: [],
      sameWithBc: false,
      deliveryCreditCardId: null,
    }
  },
  methods: {
    addCard() {
      let redirect_url = '';
      if(this.pageName == 'nselection') {
        redirect_url = 'NSelectionSelectPaymentAndShipping';
      }
      // reloadCheckをfalseにする
      this.$store.commit('setAddCreditCardReloadCheck', true);

      this.$router.push({ name: 'AddCreditCard', query: {redirect_url: redirect_url, reload_param: Math.random().toString(32).substring(2)} });
    },

    changeCredit(creditCardId) {
      this.deliveryCreditCardId = creditCardId;
      if(creditCardId == 0) {
        this.sameWithBc = true;
      } else {
        this.sameWithBc = false;
      }
    },
    close() {
      // this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.open = false;
    },
    refsOpen() {
      // 親要素からmethods実行
      this.open = true;
    },
    changeCard() {
      scrollPosition.close();
      let findItem = this.cardList.findIndex((value) => value.creditCardId == this.deliveryCreditCardId);
      if(this.sameWithBc) {
        findItem = this.cardList.findIndex((value) => value.sameWithBc001 == true);
      }
      let cardBrand = '';
      let cardNo = '✴︎✴︎✴︎✴︎✴︎✴︎';
      let creditCardId = '';
      let expireYearMonth = '';
      let expired = '';
      let holderName = '';
      let selected = true;
      let sameWithBc001 = true;
      if(findItem != -1) {
        cardBrand = this.cardList[findItem].cardBrand;
        cardNo = this.cardList[findItem].cardNo;
        creditCardId = this.cardList[findItem].creditCardId;
        expireYearMonth = this.cardList[findItem].expireYearMonth;
        expired = this.cardList[findItem].expired;
        holderName = this.cardList[findItem].holderName;
        selected = this.cardList[findItem].selected;
        sameWithBc001 = this.cardList[findItem].sameWithBc001;
      }
      this.storeCreditData(
        cardBrand,
        cardNo,
        creditCardId,
        expireYearMonth,
        expired,
        holderName,
        selected,
        sameWithBc001
      );
      this.open = false;
    },
    async apiGetCreditCardList() {
      let bc = '001';
      await creditCard.getCreditCardList(bc).then((val) => {
        console.log('クレジットカード一覧');
        console.log(val);
        if(val) {
          this.cardList.push(...val.creditCardList);
          let creditData = JSON.parse(localStorage.getItem('creditData'));
          let index = this.cardList.findIndex(({selected}) => selected);
          this.storeCreditData(this.cardList[index].cardBrand, this.cardList[index].cardNo, this.cardList[index].creditCardId, this.cardList[index].expireYearMonth, this.cardList[index].expired, this.cardList[index].holderName, this.cardList[index].selected, this.cardList[index].sameWithBc001);
          if(creditData != null) {
            this.storeCreditData(creditData.cardBrand, creditData.cardNo, creditData.creditCardId, creditData.expireYearMonth, creditData.expired, creditData.holderName, creditData.selected, creditData.sameWithBc001);
          }
        }
      });
    },
    storeCreditData(cardBrand, cardNo, creditCardId, expireYearMonth, expired, holderName, selected, sameWithBc001) {
      this.$store.commit('nselection/setCardBrand', cardBrand);
      this.$store.commit('nselection/setCardNo', cardNo);
      this.$store.commit('nselection/setCreditCardId', creditCardId);
      this.$store.commit('nselection/setExpireYearMonth', expireYearMonth);
      this.$store.commit('nselection/setExpired', expired);
      this.$store.commit('nselection/setHolderName', holderName);
      this.$store.commit('nselection/setSelected', selected);
      this.$store.commit('nselection/setSameWithBc001', sameWithBc001);
      this.$store.commit('nselection/setRequestDatacreditCardId', creditCardId);
      if(cardBrand == '' && cardNo == '' && creditCardId == '' && expireYearMonth == '' && !expired && holderName == '' && !selected && !sameWithBc001) return;
      localStorage.setItem('creditData', JSON.stringify(this.creditData));
    },
    initialized() {
      this.open = false;
      this.cardList.splice(0, this.cardList.length);
      this.sameWithBc = false;
      this.deliveryCreditCardId = null;
      this.storeCreditData('', '', '', '', false, '', false, false);
    },
  },
  computed: mapGetters(
    'nselection', [
      'creditData'
    ],
  ),
  created() {
    this.initialized();
    if(this.$route.query.status == 'addCreditCard') {
      this.open = true;
    }
    this.apiGetCreditCardList();
  }
}
</script>

<style lang="css" scoped>
.same_credit {
  font-size: 14px;
}
.modal_item {
  /* overflow: scroll; */
  padding-bottom: 100px;
}
.modal_item .scroll {
  max-height: 150px;
  padding-bottom: 40px;
  /* padding-bottom: 100px; */
}
.content_title {
  letter-spacing: 3px;
  width: 205px;
}

.credit_contents {
  align-items: center;
  display: flex;
}

.credit_image {
  max-width: 34px;
}

.credit_number {
  letter-spacing: .5px;
  margin-left: 4px;
}
.btn_blue {
  margin-top: 26px;
}
.btn_yellow {
  margin-top: 20px;
}

/* 消したいけど消すとチェックされた時に青丸が出てこない */
.payment_contents {
  cursor: pointer;
  padding-left: 28px;
  position: relative;
  width: 100%;
}

.payment_contents::before,
.payment_contents::after {
  bottom: 0;
  border-radius: 100px;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}
.payment_contents::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  height: 20px;
  left: 0;
  width: 20px;
}

.payment_contents .credit_image {
  opacity: .4;
}

.payment_radio:checked + .payment_contents .credit_image {
  opacity: 1;
}

.payment_radio:checked + .payment_contents::after {
  background: #00C2FF;
  height: 12px;
  left: 5px;
  width: 12px;
}

.payment_radio {
  display: none;
}
/* ここまで */
.card_wrap {
  max-height: 150px;
  overflow-y: scroll;
}

.btn_wrap {
  padding-bottom: 40px;
}

.item_detail.open {
  height: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/SelectCredit.vue